import { Box, Divider, Icon, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { SeamRequest } from '../../../app/model/seam-request';
import { Formatters } from '../../../app/utils/formatters';

interface RequestMenuProps {
    selectedRequest: SeamRequest;
    requestId: string;
}

export class RequestMenu extends React.Component<RequestMenuProps> {
    public render(): React.ReactNode {
        const request = this.props.selectedRequest;
        const requestId = this.props.requestId;

        return (
            <Box className='p-2'>
                <Typography variant='h5'>{Formatters.seamRequestId(request.id)}</Typography>
                <Typography variant='h6'>{request.store.name}</Typography>
                <Divider className='mt-2' />
                <List>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        to={`/seam/request/${requestId}/details`}
                    >
                        <ListItemIcon>
                            <Icon>check_box</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Details' />
                    </ListItem>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        disabled
                        to={`/seam/request/${requestId}/start`}
                    >
                        <ListItemIcon>
                            <Icon>restart_alt</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Start Work' />
                    </ListItem>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        to={`/seam/request/${requestId}/qa`}
                    >
                        <ListItemIcon>
                            <Icon>fact_check</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Data Quality' />
                    </ListItem>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        to={`/seam/request/${requestId}/history`}
                    >
                        <ListItemIcon>
                            <Icon>history</Icon>
                        </ListItemIcon>
                        <ListItemText primary='History' />
                    </ListItem>
                    <ListItem
                        button
                        activeClassName='Mui-selected'
                        component={NavLink}
                        to={`/seam/request/${requestId}/patterns`}
                    >
                        <ListItemIcon>
                            <Icon>grain</Icon>
                        </ListItemIcon>
                        <ListItemText primary='Patterns' />
                    </ListItem>
                </List>
            </Box>
        );
    }
}
